export const queue = {
  input: {
    timeout: {
      label: 'Queue Timeout'
    },

    type: {
      label: 'Distribution method'
    },

    contact_methods: {
      label: 'Contact methods'
    },

    contact_groups: {
      label: 'Groups'
    }
  },

  state: {
    init: {
      description:
        'Queue - an element of the scheme, which serves to transfer the call to the operator. A call that has not been accepted for work will go on a separate branch in the scheme - timeout.'
    },
    add_group: {
      title: 'Add group to queue'
    },

    ['add-method']: {
      title: 'Add contact method to the queue',
      description: `You can add a new contact method and group in your personal account, in the`
    }
  }
};
